module.exports = __webpack_public_path__ + "static/media/neil.75f03fd5.jpg";